export default {
      id: "oc-hcso-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-hcso",
      toString: function () {
        return this.url;
      }
    }